import { ContractAbi } from 'web3';

export const TOKEN_ABI: any = [{
  'inputs': [{ 'internalType': 'string', 'name': 'name_', 'type': 'string' }, {
    'internalType': 'string',
    'name': 'symbol_',
    'type': 'string'
  }, { 'internalType': 'address', 'name': 'taxHandlerAddress', 'type': 'address' }, {
    'internalType': 'address',
    'name': 'treasuryHandlerAddress',
    'type': 'address'
  }], 'stateMutability': 'nonpayable', 'type': 'constructor'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
    'indexed': true,
    'internalType': 'address',
    'name': 'spender',
    'type': 'address'
  }, { 'indexed': false, 'internalType': 'uint256', 'name': 'value', 'type': 'uint256' }],
  'name': 'Approval',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': false, 'internalType': 'address', 'name': 'delegator', 'type': 'address' }, {
    'indexed': false,
    'internalType': 'address',
    'name': 'currentDelegate',
    'type': 'address'
  }, { 'indexed': false, 'internalType': 'address', 'name': 'newDelegate', 'type': 'address' }],
  'name': 'DelegateChanged',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': false, 'internalType': 'address', 'name': 'delegatee', 'type': 'address' }, {
    'indexed': false,
    'internalType': 'uint224',
    'name': 'oldVotes',
    'type': 'uint224'
  }, { 'indexed': false, 'internalType': 'uint224', 'name': 'newVotes', 'type': 'uint224' }],
  'name': 'DelegateVotesChanged',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'previousOwner', 'type': 'address' }, {
    'indexed': true,
    'internalType': 'address',
    'name': 'newOwner',
    'type': 'address'
  }],
  'name': 'OwnershipTransferred',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': false, 'internalType': 'address', 'name': 'oldAddress', 'type': 'address' }, {
    'indexed': false,
    'internalType': 'address',
    'name': 'newAddress',
    'type': 'address'
  }],
  'name': 'TaxHandlerChanged',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'from', 'type': 'address' }, {
    'indexed': true,
    'internalType': 'address',
    'name': 'to',
    'type': 'address'
  }, { 'indexed': false, 'internalType': 'uint256', 'name': 'value', 'type': 'uint256' }],
  'name': 'Transfer',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': false, 'internalType': 'address', 'name': 'oldAddress', 'type': 'address' }, {
    'indexed': false,
    'internalType': 'address',
    'name': 'newAddress',
    'type': 'address'
  }],
  'name': 'TreasuryHandlerChanged',
  'type': 'event'
}, {
  'inputs': [],
  'name': 'DELEGATION_TYPEHASH',
  'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'DOMAIN_TYPEHASH',
  'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
    'internalType': 'address',
    'name': 'spender',
    'type': 'address'
  }],
  'name': 'allowance',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'spender', 'type': 'address' }, {
    'internalType': 'uint256',
    'name': 'amount',
    'type': 'uint256'
  }],
  'name': 'approve',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'account', 'type': 'address' }],
  'name': 'balanceOf',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }, { 'internalType': 'uint32', 'name': '', 'type': 'uint32' }],
  'name': 'checkpoints',
  'outputs': [{ 'internalType': 'uint32', 'name': 'blockNumber', 'type': 'uint32' }, {
    'internalType': 'uint224',
    'name': 'votes',
    'type': 'uint224'
  }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'decimals',
  'outputs': [{ 'internalType': 'uint8', 'name': '', 'type': 'uint8' }],
  'stateMutability': 'pure',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'spender', 'type': 'address' }, {
    'internalType': 'uint256',
    'name': 'subtractedValue',
    'type': 'uint256'
  }],
  'name': 'decreaseAllowance',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'delegatee', 'type': 'address' }],
  'name': 'delegate',
  'outputs': [],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'delegatee', 'type': 'address' }, {
    'internalType': 'uint256',
    'name': 'nonce',
    'type': 'uint256'
  }, { 'internalType': 'uint256', 'name': 'expiry', 'type': 'uint256' }, {
    'internalType': 'uint8',
    'name': 'v',
    'type': 'uint8'
  }, { 'internalType': 'bytes32', 'name': 'r', 'type': 'bytes32' }, { 'internalType': 'bytes32', 'name': 's', 'type': 'bytes32' }],
  'name': 'delegateBySig',
  'outputs': [],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'name': 'delegates',
  'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'account', 'type': 'address' }, {
    'internalType': 'uint32',
    'name': 'blockNumber',
    'type': 'uint32'
  }],
  'name': 'getVotesAtBlock',
  'outputs': [{ 'internalType': 'uint224', 'name': '', 'type': 'uint224' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'spender', 'type': 'address' }, {
    'internalType': 'uint256',
    'name': 'addedValue',
    'type': 'uint256'
  }],
  'name': 'increaseAllowance',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'name',
  'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'name': 'nonces',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'name': 'numCheckpoints',
  'outputs': [{ 'internalType': 'uint32', 'name': '', 'type': 'uint32' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'owner',
  'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'renounceOwnership',
  'outputs': [],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'taxHandlerAddress', 'type': 'address' }],
  'name': 'setTaxHandler',
  'outputs': [],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'treasuryHandlerAddress', 'type': 'address' }],
  'name': 'setTreasuryHandler',
  'outputs': [],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'symbol',
  'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'taxHandler',
  'outputs': [{ 'internalType': 'contract ITaxHandler', 'name': '', 'type': 'address' }],
  'stateMutability': 'view',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'totalSupply',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'stateMutability': 'pure',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'recipient', 'type': 'address' }, {
    'internalType': 'uint256',
    'name': 'amount',
    'type': 'uint256'
  }],
  'name': 'transfer',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'sender', 'type': 'address' }, {
    'internalType': 'address',
    'name': 'recipient',
    'type': 'address'
  }, { 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }],
  'name': 'transferFrom',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [{ 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }],
  'name': 'transferOwnership',
  'outputs': [],
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'inputs': [],
  'name': 'treasuryHandler',
  'outputs': [{ 'internalType': 'contract ITreasuryHandler', 'name': '', 'type': 'address' }],
  'stateMutability': 'view',
  'type': 'function'
}];
